import { StyleSheet } from "react-native";

import { ADMIN_TOKENS } from "../../../../styles/adminTokens";

export const styles = StyleSheet.create({
  page: {
    flex: 1,
    paddingHorizontal: ADMIN_TOKENS.spacing.lg,
    paddingVertical: ADMIN_TOKENS.spacing.md,
    backgroundColor: ADMIN_TOKENS.color.surface,
    gap: ADMIN_TOKENS.spacing.md,
  },
  pageTitle: {
    marginTop: ADMIN_TOKENS.spacing.xs,
  },
  callsTabs: {
    marginBottom: ADMIN_TOKENS.spacing.xs,
  },
  hiddenSection: {
    display: "none",
  },
  loadingCard: {
    borderRadius: ADMIN_TOKENS.radius.lg,
    borderWidth: ADMIN_TOKENS.borderWidth.sm,
    borderColor: ADMIN_TOKENS.color.border,
    backgroundColor: ADMIN_TOKENS.color.surface,
    padding: ADMIN_TOKENS.spacing.xxl,
    alignItems: "center",
    gap: ADMIN_TOKENS.spacing.md,
  },
  loadingText: {
    fontFamily: ADMIN_TOKENS.font.medium,
    fontSize: ADMIN_TOKENS.fontSize.sm,
    lineHeight: ADMIN_TOKENS.lineHeight.sm,
    color: ADMIN_TOKENS.color.textSecondary,
  },
  loadingInlineRow: {
    flexDirection: "row",
    alignItems: "center",
    gap: ADMIN_TOKENS.spacing.sm,
  },
  contentRow: {
    flex: 1,
    flexDirection: "row",
    gap: ADMIN_TOKENS.spacing.lg,
    minHeight: 0,
  },
  contentRowMobile: {
    flexDirection: "column",
  },
  leftPane: {
    flex: 1,
    minWidth: 0,
  },
  callsLeftPane: {
    flexBasis: "33%",
    flexGrow: 0,
    flexShrink: 1,
  },
  leftPaneContent: {
    gap: ADMIN_TOKENS.spacing.md,
    paddingBottom: ADMIN_TOKENS.spacing.massive,
  },
  rightPane: {
    flex: 1,
    minWidth: 0,
  },
  rightPaneBottomAligned: {
    justifyContent: "flex-end",
  },
  callsRightPane: {
    flexBasis: "67%",
    flexGrow: 0,
    flexShrink: 1,
  },
  messagesLeftPane: {
    flexBasis: "33%",
    flexGrow: 0,
    flexShrink: 1,
    minWidth: 0,
  },
  messagesRightPane: {
    flexBasis: "67%",
    flexGrow: 0,
    flexShrink: 1,
    minWidth: 0,
  },
  messagesPaneDivider: {
    borderRightWidth: ADMIN_TOKENS.borderWidth.sm,
    borderColor: ADMIN_TOKENS.color.borderInput,
  },
  rightPaneContent: {
    gap: ADMIN_TOKENS.spacing.md,
    paddingBottom: ADMIN_TOKENS.spacing.massive,
  },
  rightPaneContentStretchNoBottomPadding: {
    flexGrow: 1,
    paddingBottom: 0,
  },
  card: {
    borderRadius: ADMIN_TOKENS.radius.lg,
    borderWidth: ADMIN_TOKENS.borderWidth.sm,
    borderColor: ADMIN_TOKENS.color.border,
    backgroundColor: ADMIN_TOKENS.color.surface,
    ...ADMIN_TOKENS.shadow.card,
    padding: ADMIN_TOKENS.spacing.lg,
    gap: ADMIN_TOKENS.spacing.sm,
    overflow: "visible",
  },
  cardTitle: {
    fontFamily: ADMIN_TOKENS.font.semibold,
    fontSize: ADMIN_TOKENS.fontSize.md,
    lineHeight: ADMIN_TOKENS.lineHeight.md,
    color: ADMIN_TOKENS.color.textPrimary,
  },
  modeLabel: {
    alignSelf: "flex-start",
    borderRadius: ADMIN_TOKENS.radius.md,
    borderWidth: ADMIN_TOKENS.borderWidth.sm,
    borderColor: ADMIN_TOKENS.color.borderAccent,
    backgroundColor: ADMIN_TOKENS.color.surfaceAccent,
    paddingHorizontal: ADMIN_TOKENS.spacing.sm,
    paddingVertical: ADMIN_TOKENS.spacing.xs,
    color: ADMIN_TOKENS.color.accentDark,
    fontFamily: ADMIN_TOKENS.font.medium,
    fontSize: ADMIN_TOKENS.fontSize.xs,
    lineHeight: ADMIN_TOKENS.lineHeight.xs,
  },
  modeLabelMuted: {
    borderColor: ADMIN_TOKENS.color.borderMuted,
    backgroundColor: ADMIN_TOKENS.color.surfaceMuted,
    color: ADMIN_TOKENS.color.textMuted,
  },
  packageSummaryList: {
    gap: ADMIN_TOKENS.spacing.xs,
  },
  ftuiHeadline: {
    color: ADMIN_TOKENS.color.textPrimary,
    fontFamily: ADMIN_TOKENS.font.semibold,
    fontSize: ADMIN_TOKENS.fontSize.lg,
    lineHeight: ADMIN_TOKENS.lineHeight.lg,
  },
  ftuiValueBulletList: {
    gap: ADMIN_TOKENS.spacing.xs,
  },
  setupStepsCard: {
    borderRadius: ADMIN_TOKENS.radius.md,
    borderWidth: ADMIN_TOKENS.borderWidth.sm,
    borderColor: ADMIN_TOKENS.color.borderMuted,
    backgroundColor: ADMIN_TOKENS.color.surfaceMuted,
    padding: ADMIN_TOKENS.spacing.md,
    gap: ADMIN_TOKENS.spacing.xs,
  },
  inputLabel: {
    fontFamily: ADMIN_TOKENS.font.medium,
    fontSize: ADMIN_TOKENS.fontSize.sm,
    lineHeight: ADMIN_TOKENS.lineHeight.sm,
    color: ADMIN_TOKENS.color.textSecondary,
    marginTop: ADMIN_TOKENS.spacing.sm,
  },
  input: {
    minHeight: 44,
    borderRadius: ADMIN_TOKENS.radius.md,
    borderWidth: ADMIN_TOKENS.borderWidth.sm,
    borderColor: ADMIN_TOKENS.color.borderInput,
    backgroundColor: ADMIN_TOKENS.color.surface,
    color: ADMIN_TOKENS.color.textPrimary,
    paddingHorizontal: ADMIN_TOKENS.spacing.md,
    paddingVertical: ADMIN_TOKENS.spacing.sm,
    fontFamily: ADMIN_TOKENS.font.medium,
    fontSize: ADMIN_TOKENS.fontSize.md,
    lineHeight: ADMIN_TOKENS.lineHeight.md,
  },
  dialerInlineRow: {
    flexDirection: "row",
    alignItems: "center",
    gap: ADMIN_TOKENS.spacing.sm,
    flexWrap: "wrap",
  },
  dialerInlineLabel: {
    color: ADMIN_TOKENS.color.textSecondary,
    fontFamily: ADMIN_TOKENS.font.medium,
    fontSize: ADMIN_TOKENS.fontSize.sm,
    lineHeight: ADMIN_TOKENS.lineHeight.sm,
    minWidth: 44,
  },
  dialerInlineValueScroll: {
    flex: 1,
    minWidth: 0,
  },
  dialerInlineOptionsContainer: {
    flexDirection: "row",
    gap: ADMIN_TOKENS.spacing.sm,
    paddingVertical: ADMIN_TOKENS.spacing.xs,
  },
  dialerInlineToInputs: {
    flexDirection: "row",
    alignItems: "center",
    gap: ADMIN_TOKENS.spacing.xs,
    flex: 1,
    minWidth: 0,
  },
  dialerToCountryCodeInput: {
    width: 72,
    textAlign: "center",
  },
  dialerToLocalInput: {
    flex: 1,
    minWidth: 0,
  },
  toNumberRow: {
    flexDirection: "row",
    alignItems: "center",
    gap: ADMIN_TOKENS.spacing.sm,
  },
  toNumberCountryCodeInput: {
    width: ADMIN_TOKENS.size.searchButtonMinWidth,
    textAlign: "center",
  },
  toNumberLocalInput: {
    flex: 1,
    minWidth: 0,
  },
  patientSearchInputContainer: {
    marginTop: ADMIN_TOKENS.spacing.xs,
    borderColor: ADMIN_TOKENS.color.borderInput,
    backgroundColor: ADMIN_TOKENS.color.surface,
  },
  patientSearchInput: {
    color: ADMIN_TOKENS.color.textPrimary,
    fontFamily: ADMIN_TOKENS.font.medium,
    fontSize: ADMIN_TOKENS.fontSize.md,
    lineHeight: ADMIN_TOKENS.lineHeight.md,
  },
  patientSearchResults: {
    gap: ADMIN_TOKENS.spacing.xs,
    marginTop: ADMIN_TOKENS.spacing.sm,
  },
  patientSearchResultRow: {
    borderRadius: ADMIN_TOKENS.radius.md,
    borderWidth: ADMIN_TOKENS.borderWidth.sm,
    borderColor: ADMIN_TOKENS.color.border,
    backgroundColor: ADMIN_TOKENS.color.surface,
    paddingHorizontal: ADMIN_TOKENS.spacing.md,
    paddingVertical: ADMIN_TOKENS.spacing.sm,
    gap: ADMIN_TOKENS.spacing.xs,
  },
  patientSearchResultRowSelected: {
    borderColor: ADMIN_TOKENS.color.accent,
    backgroundColor: ADMIN_TOKENS.color.surfaceAccent,
  },
  selectedPatientPanel: {
    marginTop: ADMIN_TOKENS.spacing.sm,
    borderRadius: ADMIN_TOKENS.radius.md,
    borderWidth: ADMIN_TOKENS.borderWidth.sm,
    borderColor: ADMIN_TOKENS.color.borderMuted,
    backgroundColor: ADMIN_TOKENS.color.surface,
    paddingHorizontal: ADMIN_TOKENS.spacing.md,
    paddingVertical: ADMIN_TOKENS.spacing.sm,
    gap: ADMIN_TOKENS.spacing.xs,
  },
  inlineOptionButton: {
    minHeight: 44,
    justifyContent: "center",
    borderRadius: ADMIN_TOKENS.radius.md,
    borderWidth: ADMIN_TOKENS.borderWidth.sm,
    borderColor: ADMIN_TOKENS.color.border,
    backgroundColor: ADMIN_TOKENS.color.surface,
    paddingHorizontal: ADMIN_TOKENS.spacing.md,
    paddingVertical: ADMIN_TOKENS.spacing.sm,
  },
  inlineOptionButtonActive: {
    backgroundColor: ADMIN_TOKENS.color.surfaceAccent,
    borderColor: ADMIN_TOKENS.color.borderAccent,
  },
  inlineOptionText: {
    color: ADMIN_TOKENS.color.textSecondary,
    fontFamily: ADMIN_TOKENS.font.medium,
    fontSize: ADMIN_TOKENS.fontSize.sm,
    lineHeight: ADMIN_TOKENS.lineHeight.sm,
  },
  inlineOptionTextActive: {
    color: ADMIN_TOKENS.color.accentDark,
  },
  routingSwitchRow: {
    marginTop: ADMIN_TOKENS.spacing.xs,
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    gap: ADMIN_TOKENS.spacing.sm,
  },
  routingOptionWrap: {
    flexDirection: "row",
    flexWrap: "wrap",
    gap: ADMIN_TOKENS.spacing.sm,
  },
  routingModeHeaderRow: {
    marginTop: ADMIN_TOKENS.spacing.xs,
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    gap: ADMIN_TOKENS.spacing.sm,
  },
  routingInfoButton: {
    minHeight: 32,
    flexDirection: "row",
    alignItems: "center",
    gap: ADMIN_TOKENS.spacing.xs,
    paddingHorizontal: ADMIN_TOKENS.spacing.xs,
    paddingVertical: ADMIN_TOKENS.spacing.xs,
    borderRadius: ADMIN_TOKENS.radius.sm,
  },
  routingInfoButtonText: {
    color: ADMIN_TOKENS.color.textSecondary,
    fontFamily: ADMIN_TOKENS.font.medium,
    fontSize: ADMIN_TOKENS.fontSize.xs,
    lineHeight: ADMIN_TOKENS.lineHeight.xs,
  },
  routingInfoPanel: {
    borderRadius: ADMIN_TOKENS.radius.md,
    borderWidth: ADMIN_TOKENS.borderWidth.sm,
    borderColor: ADMIN_TOKENS.color.borderMuted,
    backgroundColor: ADMIN_TOKENS.color.surfaceMuted,
    paddingHorizontal: ADMIN_TOKENS.spacing.md,
    paddingVertical: ADMIN_TOKENS.spacing.sm,
    gap: ADMIN_TOKENS.spacing.xs,
  },
  routingOptionButton: {
    minWidth: ADMIN_TOKENS.size.inlineButtonMinWidth,
  },
  routingUserList: {
    gap: ADMIN_TOKENS.spacing.sm,
  },
  routingUserOption: {
    borderRadius: ADMIN_TOKENS.radius.md,
    borderWidth: ADMIN_TOKENS.borderWidth.sm,
    borderColor: ADMIN_TOKENS.color.border,
    backgroundColor: ADMIN_TOKENS.color.surface,
    paddingHorizontal: ADMIN_TOKENS.spacing.md,
    paddingVertical: ADMIN_TOKENS.spacing.sm,
    gap: ADMIN_TOKENS.spacing.xs,
  },
  inlineErrorText: {
    color: ADMIN_TOKENS.color.errorText,
    fontFamily: ADMIN_TOKENS.font.medium,
    fontSize: ADMIN_TOKENS.fontSize.sm,
    lineHeight: ADMIN_TOKENS.lineHeight.sm,
  },
  errorCard: {
    borderRadius: ADMIN_TOKENS.radius.md,
    borderWidth: ADMIN_TOKENS.borderWidth.sm,
    borderColor: ADMIN_TOKENS.color.errorBorder,
    backgroundColor: ADMIN_TOKENS.color.errorSurface,
    padding: ADMIN_TOKENS.spacing.md,
  },
  errorText: {
    color: ADMIN_TOKENS.color.errorTextStrong,
    fontFamily: ADMIN_TOKENS.font.medium,
    fontSize: ADMIN_TOKENS.fontSize.sm,
    lineHeight: ADMIN_TOKENS.lineHeight.sm,
  },
  feedbackToast: {
    position: "absolute",
    top: ADMIN_TOKENS.spacing.md,
    right: ADMIN_TOKENS.spacing.lg,
    maxWidth: 520,
    zIndex: ADMIN_TOKENS.zIndex.above,
  },
  rowBetween: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    gap: ADMIN_TOKENS.spacing.sm,
  },
  listContainer: {
    gap: ADMIN_TOKENS.spacing.sm,
    position: "relative",
    zIndex: ADMIN_TOKENS.zIndex.base,
  },
  summaryChipsRow: {
    flexDirection: "row",
    flexWrap: "wrap",
    gap: ADMIN_TOKENS.spacing.sm,
  },
  summaryChip: {
    borderRadius: ADMIN_TOKENS.radius.md,
    borderWidth: ADMIN_TOKENS.borderWidth.sm,
    borderColor: ADMIN_TOKENS.color.borderAccent,
    backgroundColor: ADMIN_TOKENS.color.surfaceAccent,
    paddingHorizontal: ADMIN_TOKENS.spacing.sm,
    paddingVertical: ADMIN_TOKENS.spacing.xs,
  },
  summaryChipText: {
    color: ADMIN_TOKENS.color.accentDark,
    fontFamily: ADMIN_TOKENS.font.medium,
    fontSize: ADMIN_TOKENS.fontSize.xs,
    lineHeight: ADMIN_TOKENS.lineHeight.xs,
  },
  callRow: {
    borderRadius: ADMIN_TOKENS.radius.md,
    borderWidth: ADMIN_TOKENS.borderWidth.sm,
    borderColor: ADMIN_TOKENS.color.border,
    padding: ADMIN_TOKENS.spacing.md,
    gap: ADMIN_TOKENS.spacing.xs,
    backgroundColor: ADMIN_TOKENS.color.surface,
  },
  callRowContent: {
    gap: ADMIN_TOKENS.spacing.xs,
  },
  callHeaderLeft: {
    flexDirection: "row",
    alignItems: "flex-start",
    flexWrap: "wrap",
    gap: ADMIN_TOKENS.spacing.xs,
    flex: 1,
    minWidth: 0,
  },
  callPatientNameText: {
    flexShrink: 1,
    minWidth: 0,
  },
  callNameWithEditWrap: {
    flexDirection: "row",
    alignItems: "center",
    alignSelf: "flex-start",
    maxWidth: "100%",
    gap: ADMIN_TOKENS.spacing.xs,
    flexShrink: 1,
  },
  callRowSelected: {
    borderColor: ADMIN_TOKENS.color.accent,
    backgroundColor: ADMIN_TOKENS.color.surfaceAccent,
  },
  callRowActions: {
    marginTop: ADMIN_TOKENS.spacing.xs,
    flexDirection: "row",
    justifyContent: "flex-end",
    gap: ADMIN_TOKENS.spacing.sm,
  },
  callAgainIconButton: {
    width: 44,
    height: 44,
    borderRadius: ADMIN_TOKENS.radius.xxl,
    borderWidth: ADMIN_TOKENS.borderWidth.sm,
    borderColor: ADMIN_TOKENS.color.borderAccent,
    backgroundColor: ADMIN_TOKENS.color.surfaceAccent,
    alignItems: "center",
    justifyContent: "center",
  },
  callMetaInlineRow: {
    flexDirection: "row",
    alignItems: "flex-end",
    justifyContent: "space-between",
    gap: ADMIN_TOKENS.spacing.sm,
  },
  callMetaInlineLeft: {
    flex: 1,
    minWidth: 0,
    gap: ADMIN_TOKENS.spacing.xs,
  },
  callAgainButton: {
    minHeight: 44,
    minWidth: ADMIN_TOKENS.size.inlineButtonMinWidth,
    justifyContent: "center",
    borderRadius: ADMIN_TOKENS.radius.md,
    borderWidth: ADMIN_TOKENS.borderWidth.sm,
    borderColor: ADMIN_TOKENS.color.borderAccent,
    backgroundColor: ADMIN_TOKENS.color.surfaceAccent,
    paddingHorizontal: ADMIN_TOKENS.spacing.md,
    paddingVertical: ADMIN_TOKENS.spacing.sm,
  },
  callsPaginationButton: {
    alignSelf: "flex-start",
  },
  messageUnreadToggle: {
    minWidth: ADMIN_TOKENS.size.searchButtonMinWidth,
  },
  messageInboxHeaderActions: {
    flexDirection: "row",
    alignItems: "center",
    gap: ADMIN_TOKENS.spacing.sm,
    position: "relative",
    zIndex: ADMIN_TOKENS.zIndex.base,
  },
  messagesInboxPanel: {
    gap: ADMIN_TOKENS.spacing.md,
    position: "relative",
    zIndex: ADMIN_TOKENS.zIndex.base,
    overflow: "visible",
  },
  messagesInboxToolbar: {
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "space-between",
    alignItems: "center",
    gap: ADMIN_TOKENS.spacing.sm,
    position: "relative",
    zIndex: ADMIN_TOKENS.zIndex.above,
  },
  messageInboxCompactToolbarRow: {
    width: "100%",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    gap: ADMIN_TOKENS.spacing.sm,
  },
  messageFilterButton: {
    flexDirection: "row",
    alignItems: "center",
    gap: ADMIN_TOKENS.spacing.xs,
  },
  messagesFiltersRow: {
    flexDirection: "row",
    flexWrap: "nowrap",
    alignItems: "center",
    gap: ADMIN_TOKENS.spacing.sm,
    flexGrow: 1,
    minWidth: 0,
    position: "relative",
    zIndex: ADMIN_TOKENS.zIndex.above + 2,
  },
  messageFilterChipRow: {
    flexDirection: "row",
    alignItems: "center",
    gap: ADMIN_TOKENS.spacing.xs,
    paddingVertical: ADMIN_TOKENS.spacing.xs,
  },
  messageFilterChip: {
    minHeight: 36,
    borderRadius: ADMIN_TOKENS.radius.md,
    borderWidth: ADMIN_TOKENS.borderWidth.sm,
    borderColor: ADMIN_TOKENS.color.borderAccent,
    backgroundColor: ADMIN_TOKENS.color.surfaceAccent,
    paddingHorizontal: ADMIN_TOKENS.spacing.sm,
    paddingVertical: ADMIN_TOKENS.spacing.xs,
    flexDirection: "row",
    alignItems: "center",
    gap: ADMIN_TOKENS.spacing.xs,
  },
  messageFilterChipText: {
    color: ADMIN_TOKENS.color.accentDark,
    fontFamily: ADMIN_TOKENS.font.medium,
    fontSize: ADMIN_TOKENS.fontSize.xs,
    lineHeight: ADMIN_TOKENS.lineHeight.xs,
  },
  messagesFilterGroup: {
    gap: ADMIN_TOKENS.spacing.xs,
  },
  dropdownLayerHost: {
    position: "relative",
    zIndex: ADMIN_TOKENS.zIndex.above + 2,
  },
  messagesFilterGroupInline: {
    flexDirection: "row",
    alignItems: "center",
    gap: ADMIN_TOKENS.spacing.xs,
    flexShrink: 0,
  },
  messagesFilterLabel: {
    color: ADMIN_TOKENS.color.textSecondary,
    fontFamily: ADMIN_TOKENS.font.medium,
    fontSize: ADMIN_TOKENS.fontSize.xs,
    lineHeight: ADMIN_TOKENS.lineHeight.xs,
  },
  saveStatusDropdownContainer: {
    position: "relative",
    zIndex: ADMIN_TOKENS.zIndex.base,
  },
  saveStatusDropdownContainerOpen: {
    zIndex: ADMIN_TOKENS.zIndex.above,
  },
  assignedNumberDropdownContainer: {
    position: "relative",
    zIndex: ADMIN_TOKENS.zIndex.base,
  },
  assignedNumberDropdownContainerOpen: {
    zIndex: ADMIN_TOKENS.zIndex.above,
  },
  assignedNumberDropdownTrigger: {
    minWidth: ADMIN_TOKENS.size.inlineButtonMinWidth,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    gap: ADMIN_TOKENS.spacing.xs,
  },
  assignedNumberDropdownMenu: {
    position: "absolute",
    top: "100%",
    marginTop: ADMIN_TOKENS.spacing.xs,
    left: 0,
    zIndex: ADMIN_TOKENS.zIndex.above + 1,
    minWidth: 180,
    borderRadius: ADMIN_TOKENS.radius.md,
    borderWidth: ADMIN_TOKENS.borderWidth.sm,
    borderColor: ADMIN_TOKENS.color.border,
    backgroundColor: ADMIN_TOKENS.color.surface,
    ...ADMIN_TOKENS.shadow.card,
    padding: ADMIN_TOKENS.spacing.sm,
    gap: ADMIN_TOKENS.spacing.xs,
  },
  assignedNumberDropdownItem: {
    minHeight: 44,
    justifyContent: "center",
  },
  saveStatusDropdownTrigger: {
    minWidth: ADMIN_TOKENS.size.inlineButtonMinWidth,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    gap: ADMIN_TOKENS.spacing.xs,
  },
  saveStatusDropdownMenu: {
    position: "absolute",
    top: "100%",
    marginTop: ADMIN_TOKENS.spacing.xs,
    left: 0,
    zIndex: ADMIN_TOKENS.zIndex.above + 1,
    minWidth: 180,
    borderRadius: ADMIN_TOKENS.radius.md,
    borderWidth: ADMIN_TOKENS.borderWidth.sm,
    borderColor: ADMIN_TOKENS.color.border,
    backgroundColor: ADMIN_TOKENS.color.surface,
    ...ADMIN_TOKENS.shadow.card,
    padding: ADMIN_TOKENS.spacing.sm,
    gap: ADMIN_TOKENS.spacing.xs,
  },
  saveStatusDropdownItem: {
    flexDirection: "row",
    alignItems: "center",
    gap: ADMIN_TOKENS.spacing.sm,
  },
  saveStatusCheckbox: {
    width: 18,
    height: 18,
    borderRadius: ADMIN_TOKENS.radius.sm,
    borderWidth: ADMIN_TOKENS.borderWidth.sm,
    borderColor: ADMIN_TOKENS.color.borderMuted,
    backgroundColor: ADMIN_TOKENS.color.surface,
    alignItems: "center",
    justifyContent: "center",
  },
  saveStatusCheckboxChecked: {
    borderColor: ADMIN_TOKENS.color.borderAccent,
    backgroundColor: ADMIN_TOKENS.color.surfaceAccent,
  },
  messagesInboxToolbarTitle: {
    color: ADMIN_TOKENS.color.textPrimary,
    fontFamily: ADMIN_TOKENS.font.semibold,
    fontSize: ADMIN_TOKENS.fontSize.md,
    lineHeight: ADMIN_TOKENS.lineHeight.md,
  },
  messagesInboxList: {
    gap: ADMIN_TOKENS.spacing.sm,
  },
  messagesThreadPanel: {
    gap: ADMIN_TOKENS.spacing.sm,
  },
  messagesThreadPanelStretch: {
    flex: 1,
  },
  messageNewButton: {
    minWidth: ADMIN_TOKENS.size.inlineButtonMinWidth,
  },
  inlineIconButton: {
    minHeight: 28,
    minWidth: 28,
    borderRadius: ADMIN_TOKENS.radius.sm,
    borderWidth: ADMIN_TOKENS.borderWidth.sm,
    borderColor: ADMIN_TOKENS.color.borderMuted,
    backgroundColor: ADMIN_TOKENS.color.surface,
    alignItems: "center",
    justifyContent: "center",
    paddingHorizontal: ADMIN_TOKENS.spacing.xs,
    paddingVertical: ADMIN_TOKENS.spacing.xs,
  },
  callAgainButtonDisabled: {
    borderColor: ADMIN_TOKENS.color.borderMuted,
    backgroundColor: ADMIN_TOKENS.color.surfaceMuted,
    opacity: ADMIN_TOKENS.opacity.disabled,
  },
  callAgainButtonText: {
    color: ADMIN_TOKENS.color.accentDark,
    fontFamily: ADMIN_TOKENS.font.medium,
    fontSize: ADMIN_TOKENS.fontSize.sm,
    lineHeight: ADMIN_TOKENS.lineHeight.sm,
  },
  recordingActionsRow: {
    marginTop: ADMIN_TOKENS.spacing.xs,
    flexDirection: "row",
    flexWrap: "wrap",
    gap: ADMIN_TOKENS.spacing.sm,
  },
  recordingActionButton: {
    alignSelf: "flex-start",
  },
  recordingPlayerContainer: {
    marginTop: ADMIN_TOKENS.spacing.sm,
    borderRadius: ADMIN_TOKENS.radius.md,
    borderWidth: ADMIN_TOKENS.borderWidth.sm,
    borderColor: ADMIN_TOKENS.color.borderMuted,
    padding: ADMIN_TOKENS.spacing.sm,
    backgroundColor: ADMIN_TOKENS.color.surface,
  },
  statusBadge: {
    borderRadius: ADMIN_TOKENS.radius.md,
    borderWidth: ADMIN_TOKENS.borderWidth.sm,
    paddingHorizontal: ADMIN_TOKENS.spacing.sm,
    paddingVertical: ADMIN_TOKENS.spacing.xs,
  },
  statusBadgeText: {
    fontFamily: ADMIN_TOKENS.font.medium,
    fontSize: ADMIN_TOKENS.fontSize.xs,
    lineHeight: ADMIN_TOKENS.lineHeight.xs,
    textTransform: "capitalize",
  },
  statusBadgePlainText: {
    fontFamily: ADMIN_TOKENS.font.medium,
    fontSize: ADMIN_TOKENS.fontSize.xs,
    lineHeight: ADMIN_TOKENS.lineHeight.xs,
    textTransform: "capitalize",
  },
  primaryBadge: {
    borderColor: ADMIN_TOKENS.color.borderAccent,
    backgroundColor: ADMIN_TOKENS.color.surfaceAccent,
  },
  primaryBadgeText: {
    color: ADMIN_TOKENS.color.accentDark,
  },
  secondaryStatusBadge: {
    borderColor: ADMIN_TOKENS.color.borderMuted,
    backgroundColor: ADMIN_TOKENS.color.surfaceMuted,
  },
  secondaryStatusBadgeText: {
    color: ADMIN_TOKENS.color.textSecondary,
  },
  callNumberText: {
    color: ADMIN_TOKENS.color.textPrimary,
    fontFamily: ADMIN_TOKENS.font.semibold,
    fontSize: ADMIN_TOKENS.fontSize.sm,
    lineHeight: ADMIN_TOKENS.lineHeight.sm,
  },
  metaText: {
    color: ADMIN_TOKENS.color.textSecondary,
    fontFamily: ADMIN_TOKENS.font.regular,
    fontSize: ADMIN_TOKENS.fontSize.sm,
    lineHeight: ADMIN_TOKENS.lineHeight.sm,
  },
  emptyText: {
    color: ADMIN_TOKENS.color.textMuted,
    fontFamily: ADMIN_TOKENS.font.regular,
    fontSize: ADMIN_TOKENS.fontSize.sm,
    lineHeight: ADMIN_TOKENS.lineHeight.sm,
  },
  sectionStack: {
    gap: ADMIN_TOKENS.spacing.xs,
  },
  messageThreadSectionMobile: {
    flex: 1,
    justifyContent: "space-between",
  },
  messageThreadBody: {
    marginTop: ADMIN_TOKENS.spacing.xs,
    borderRadius: ADMIN_TOKENS.radius.md,
    borderWidth: ADMIN_TOKENS.borderWidth.sm,
    borderColor: ADMIN_TOKENS.color.borderMuted,
    backgroundColor: ADMIN_TOKENS.color.surface,
    padding: ADMIN_TOKENS.spacing.md,
    gap: ADMIN_TOKENS.spacing.sm,
  },
  messageBubbleList: {
    gap: ADMIN_TOKENS.spacing.xs,
  },
  messageComposerContainer: {
    marginTop: ADMIN_TOKENS.spacing.sm,
    gap: ADMIN_TOKENS.spacing.xs,
  },
  messageFromNumberRow: {
    flexDirection: "row",
    flexWrap: "wrap",
    gap: ADMIN_TOKENS.spacing.sm,
  },
  messageFromNumberButton: {
    minWidth: ADMIN_TOKENS.size.inlineButtonMinWidth,
  },
  messageComposerInput: {
    minHeight: ADMIN_TOKENS.spacing.giant * 2,
  },
  messageAssignButton: {
    flexDirection: "row",
    alignItems: "center",
    gap: ADMIN_TOKENS.spacing.xs,
    minWidth: ADMIN_TOKENS.size.searchButtonMinWidth,
  },
  messageFilterSheetBody: {
    maxHeight: 360,
  },
  messageFilterSheetBodyContent: {
    gap: ADMIN_TOKENS.spacing.md,
    paddingBottom: ADMIN_TOKENS.spacing.sm,
  },
  messageFilterOptionsStack: {
    gap: ADMIN_TOKENS.spacing.xs,
  },
  messageFilterPillRow: {
    flexDirection: "row",
    flexWrap: "wrap",
    gap: ADMIN_TOKENS.spacing.sm,
  },
  messageFilterSheetActionsRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    gap: ADMIN_TOKENS.spacing.sm,
  },
  mobileMessagesBackNav: {
    alignSelf: "flex-start",
    minHeight: 44,
    flexDirection: "row",
    alignItems: "center",
    gap: ADMIN_TOKENS.spacing.xs,
    paddingHorizontal: ADMIN_TOKENS.spacing.xs,
    paddingVertical: ADMIN_TOKENS.spacing.xs,
  },
  mobileMessagesBackNavText: {
    color: ADMIN_TOKENS.color.accentDark,
    fontFamily: ADMIN_TOKENS.font.semibold,
    fontSize: ADMIN_TOKENS.fontSize.sm,
    lineHeight: ADMIN_TOKENS.lineHeight.sm,
  },
  usageDateRow: {
    flexDirection: "row",
    flexWrap: "wrap",
    alignItems: "center",
    gap: ADMIN_TOKENS.spacing.sm,
  },
  usageDateInput: {
    flex: 1,
    minWidth: 160,
  },
  usageProgressTrack: {
    width: "100%",
    height: ADMIN_TOKENS.spacing.sm,
    borderRadius: ADMIN_TOKENS.radius.xxl,
    backgroundColor: ADMIN_TOKENS.color.surfaceMuted,
    overflow: "hidden",
    marginTop: ADMIN_TOKENS.spacing.xs,
  },
  usageProgressFill: {
    height: "100%",
    borderRadius: ADMIN_TOKENS.radius.xxl,
    backgroundColor: ADMIN_TOKENS.color.accent,
  },
  usageProgressFillOverage: {
    backgroundColor: ADMIN_TOKENS.color.errorText,
  },
  overageWarningCard: {
    marginTop: ADMIN_TOKENS.spacing.xs,
    borderRadius: ADMIN_TOKENS.radius.md,
    borderWidth: ADMIN_TOKENS.borderWidth.sm,
    borderColor: ADMIN_TOKENS.color.errorBorder,
    backgroundColor: ADMIN_TOKENS.color.errorSurface,
    padding: ADMIN_TOKENS.spacing.md,
  },
  liveCallPanel: {
    marginTop: ADMIN_TOKENS.spacing.sm,
    borderRadius: ADMIN_TOKENS.radius.md,
    borderWidth: ADMIN_TOKENS.borderWidth.sm,
    borderColor: ADMIN_TOKENS.color.borderMuted,
    padding: ADMIN_TOKENS.spacing.md,
    gap: ADMIN_TOKENS.spacing.xs,
    backgroundColor: ADMIN_TOKENS.color.surface,
  },
  recordingRow: {
    borderRadius: ADMIN_TOKENS.radius.md,
    borderWidth: ADMIN_TOKENS.borderWidth.sm,
    borderColor: ADMIN_TOKENS.color.borderMuted,
    padding: ADMIN_TOKENS.spacing.md,
    gap: ADMIN_TOKENS.spacing.xs,
    backgroundColor: ADMIN_TOKENS.color.surface,
  },
  noteRow: {
    borderRadius: ADMIN_TOKENS.radius.md,
    borderWidth: ADMIN_TOKENS.borderWidth.sm,
    borderColor: ADMIN_TOKENS.color.borderMuted,
    padding: ADMIN_TOKENS.spacing.md,
    gap: ADMIN_TOKENS.spacing.xs,
    backgroundColor: ADMIN_TOKENS.color.surface,
  },
  artifactRecordingSection: {
    gap: ADMIN_TOKENS.spacing.xs,
  },
  linkText: {
    color: ADMIN_TOKENS.color.accentDark,
    fontFamily: ADMIN_TOKENS.font.regular,
    fontSize: ADMIN_TOKENS.fontSize.xs,
    lineHeight: ADMIN_TOKENS.lineHeight.xs,
  },
  assignModalOverlay: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    padding: ADMIN_TOKENS.spacing.lg,
    backgroundColor: ADMIN_TOKENS.color.surfaceMuted,
  },
  assignModalCard: {
    width: "100%",
    maxWidth: ADMIN_TOKENS.size.eventCardMaxWidth,
    borderRadius: ADMIN_TOKENS.radius.lg,
    borderWidth: ADMIN_TOKENS.borderWidth.sm,
    borderColor: ADMIN_TOKENS.color.border,
    backgroundColor: ADMIN_TOKENS.color.surface,
    padding: ADMIN_TOKENS.spacing.lg,
    gap: ADMIN_TOKENS.spacing.sm,
  },
  assignModalPatientList: {
    maxHeight: ADMIN_TOKENS.spacing.massive * 6,
    marginTop: ADMIN_TOKENS.spacing.xs,
  },
  assignModalActionsRow: {
    marginTop: ADMIN_TOKENS.spacing.sm,
    flexDirection: "row",
    justifyContent: "flex-end",
    alignItems: "center",
    gap: ADMIN_TOKENS.spacing.sm,
  },
  assignModalSecondaryButton: {
    minHeight: 44,
    minWidth: ADMIN_TOKENS.size.inlineButtonMinWidth,
    justifyContent: "center",
    alignItems: "center",
    borderRadius: ADMIN_TOKENS.radius.md,
    borderWidth: ADMIN_TOKENS.borderWidth.sm,
    borderColor: ADMIN_TOKENS.color.border,
    backgroundColor: ADMIN_TOKENS.color.surface,
    paddingHorizontal: ADMIN_TOKENS.spacing.md,
    paddingVertical: ADMIN_TOKENS.spacing.sm,
  },
  assignModalSecondaryButtonText: {
    color: ADMIN_TOKENS.color.textSecondary,
    fontFamily: ADMIN_TOKENS.font.medium,
    fontSize: ADMIN_TOKENS.fontSize.sm,
    lineHeight: ADMIN_TOKENS.lineHeight.sm,
  },
});
